import Main from "./Components/tic-tac-toe/Main"
function App() {
  return (
    <Main/>
  );
}

export default App;
